export enum TrackerContentType {
    Image = 'image',
    Script = 'script'
}
